import styles from './index.module.less'
import classNames from 'classnames'
import AddressHash from '@/components/AddressHash'
import { useTranslation } from 'react-i18next'
import type { IAccountDetail } from '@/api/moduleAccount/interface.ts'
import useMeNavigate from '@/hooks/useMeNavigate'
import { getTransactionType } from '../../utils'
import { useMemo } from 'react'
import { isEmptyOrNil } from '@/utils'
import { useParams } from 'react-router-dom'

const ModuleAccountDetailCard = ({
  style = {},
  accountDetail,
}: {
  style?: React.CSSProperties
  accountDetail: IAccountDetail
}) => {
  const { t } = useTranslation()
  const navigate = useMeNavigate()
  const { address } = useParams()
  const typesName = getTransactionType('ModuleAddressName')
  const typesDescription = getTransactionType('ModuleAddressDesc')
  const name = typesName.pageKeyList.find((item: any) => item.key === accountDetail.name)?.label
  const description =
    address === 'gea1k9f0tr647y0agx9yue65vkmqz24h0nj0acd0vn'
      ? t('explorer_265')
      : typesDescription.pageKeyList.find((item: any) => item.key === accountDetail.name)?.label

  const regionId = useMemo(() => {
    if (isEmptyOrNil(accountDetail.regionId)) return '-'
    if (accountDetail?.regionId?.toLocaleLowerCase() === 'global_village') {
      return t('explorer_266')
    }
    return accountDetail.regionId
  }, [accountDetail.regionId])

  return (
    <div style={{ ...style }} className={styles.wrap}>
      <div className={styles.item}>
        {/* 地址 */}
        <span>{t('explorer_114')}:</span>
        <div className={classNames(styles.textStyleOne, 'font_14')}>
          <AddressHash data={accountDetail.address} copyIcon={'gray'}></AddressHash>
        </div>
      </div>
      {/* 资产 */}
      <div className={styles.item}>
        <span>
          {t('explorer_216')}:{/* {' ( GEA )'}: */}
        </span>
        <div>
          <div className={classNames(styles.textStyleOne, 'font_14')}>
            {accountDetail?.geaAmount ? (
              <>
                {accountDetail?.geaAmount}{' '}
                <span className={styles.textStyleThree}>{accountDetail?.sigin}</span>
              </>
            ) : (
              '-'
            )}
          </div>
        </div>
      </div>
      <div className={styles.item}>
        <span>
          {t('explorer_216')}:{/* {' ( GAG )'}: */}
        </span>
        <div>
          <div className={classNames(styles.textStyleOne, 'font_14')}>
            {accountDetail?.gagAmount ? (
              <>
                {accountDetail?.gagAmount}{' '}
                <span className={styles.textStyleThree}>{accountDetail?.gagSigin}</span>
              </>
            ) : (
              '-'
            )}
          </div>
        </div>
      </div>
      {/* 名称 */}
      <div className={styles.item}>
        <span>{t('explorer_171')}:</span>
        <div className={classNames(styles.textStyleOne, 'font_14')}>
          <span className={accountDetail?.name === '-' ? styles.grey : ''}>
            {name ? name : '-'}
          </span>
        </div>
      </div>
      {/* 描述 */}
      <div className={styles.item}>
        <span>{t('explorer_217')}:</span>
        <div className={classNames(styles.textStyleOne, 'font_14')}>
          {description ? description : '-'}
        </div>
      </div>
      <div className={styles.item}>
        {/* 国家/区 */}
        <span>{t('explorer_39')}:</span>
        <div
          className={classNames(
            styles.textStyleTwo,
            accountDetail?.regionId === '-' ? styles.grey : styles.cursor_pointer,
            'font_14',
          )}
        >
          <AddressHash
            data={regionId}
            handleJump={() => {
              if (accountDetail?.regionId === '-' || !accountDetail?.regionId) return
              navigate(`/countryRegion/${accountDetail?.regionId.toLowerCase()}`)
            }}
          ></AddressHash>
        </div>
      </div>
    </div>
  )
}

export default ModuleAccountDetailCard
